import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import titleize from 'titleize'
import KEYCODE from 'keycode'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import FiltersSingleSelectPanel from './filtersPanel/singleSelect'
import { reportOpenSearchFilterPanel } from '../../../../common/analytics/filtersAnalytics'
import CodeIcon from '../../../shared/components/icons/code'
import ArrowFillRightIcon from '../../../shared/components/icons/arrowFillRight'
import RightOpenIcon from '../../../shared/components/icons/rightOpen'

class FiltersSoftwareVersion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Software version')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  filterOption(items, chosenPlatform) {
    return items.filter((item, idx) => {
      return (
        item.key.indexOf(chosenPlatform) > -1 && item.key !== chosenPlatform
      )
    })
  }

  render() {
    const { showPanel } = this.state
    const { items, locationParams, platformRootCount } = this.props

    const chosenPlatform = locationParams.platform || ''
    const chosenPlatformArray = chosenPlatform.split(' ')
    const chosenPlatformLength = chosenPlatformArray.length
    const filteredPlatformItems = this.filterOption(items, chosenPlatform)

    const renderChosenPlatform = () => {
      if (chosenPlatform === '') {
        return (
          <ul className="search-facet-listing">
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">
                      {titleize(item.key)}
                    </span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        const getChosenPlatformDisplayName = chosenPlatform => {
          return chosenPlatformArray.map((platformName, index) => {
            const isLast = index === chosenPlatformLength - 1
            return (
              <div key={index} className="search-facet-panel__status-title">
                {titleize(platformName)}
                {!isLast && <ArrowFillRightIcon />}
              </div>
            )
          })
        }
        return (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              {getChosenPlatformDisplayName(chosenPlatform)}
            </div>
          </div>
        )
      }
    }

    const { isAtTop } = this.props
    const { isAtBottom } = this.props
    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-panel__header': !isAtTop && !isAtBottom,
      'search-facet-panel__header--one-facet': isAtTop && isAtBottom,
      'search-facet-panel__header--end': isAtBottom,
      'is-active': showPanel
    })

    return (
      <div className="search-facet--no-margin" id="software-version-filter">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <CodeIcon /> Software version
            <span style={{ float: 'right' }}>
              <RightOpenIcon />
            </span>
          </h2>
          {renderChosenPlatform()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersSingleSelectPanel
                rootCount={platformRootCount}
                showPanel={showPanel}
                items={filteredPlatformItems}
                locationParams={locationParams}
                togglePanel={this.togglePanel}
                breadcrumbsLabel="software versions"
                type="platform"
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersSoftwareVersion.propTypes = {
  items: PropTypes.array.isRequired,
  locationParams: PropTypes.object.isRequired,
  platformRootCount: PropTypes.number.isRequired
}

export default FiltersSoftwareVersion
